/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, {
    useEffect, useState,
} from "react";
import Bread from "modules/layoutModule/components/Bread/Bread";
import {
    HomeOutlined, EditOutlined, DeleteFilled,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
    Breadcrumb, Pagination, Popconfirm, ConfigProvider, BackTop,
} from "antd";
import {
    Table, Space, Tooltip, Button,
} from "antd";
import TableDateRow from "modules/layoutModule/components/TableDateRow/TableDateRow";
import {
    removeSpecificKnowledgeRequest, getKnowledgeRequest,
} from 'modules/knowledgeModule/requests/knowledgeRequests';
import plPL from 'antd/lib/locale/pl_PL';
import moment from 'moment';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';
import useColumnSearch from 'modules/layoutModule/hooks/useColumnSearch';


export interface NewsTableTypes {
    id: number;
    dateAdd: moment.MomentInput;
    name: string;
}

const News = (): JSX.Element => {
    const [tableData, setTableData] = useState<NewsTableTypes[]>([]);
    const [loading, toggleLoading] = useState<boolean>(true);
    const [searchedColumn, setSearchedColumn] = useState('');

    const confirmDelete = (id: number) => removeSpecificKnowledgeRequest(id);

    const downloadNews = () => getKnowledgeRequest().then(response => {
        if (response) {
            const { data } = response;
            setTableData(data);
            toggleLoading(false);
        }
        else {
            toggleLoading(false);
        }
    });

    useEffect(() => {
        if (tableData.length === 0) {
            downloadNews();
        }
    }, [tableData]);

    const columns = [
        {
            title: "Data",
            dataIndex: "dateAdd",
            key: "dateAdd",
            width: 220,
            render: (text: string, record: { type: number; dateAdd: Date; id: number; isActive: number | boolean; taste: number; colour: number; category?: string | undefined; url: string | undefined }) => <TableDateRow record={record} field={TableDataRowTypes.DATE_ADD} />,
            sorter: (a: { dateAdd: moment.MomentInput; }, b: { dateAdd: moment.MomentInput; }) => moment(a.dateAdd).unix() - moment(b.dateAdd).unix(),
        },
        {
            title: "Pytanie",
            dataIndex: "question",
            key: "question",
            sorter: (a: { question: string; }, b: { question: string; }) => a.question.localeCompare(b.question),
            ...useColumnSearch('name', 'Szukaj po pytaniu', 'Szukaj', 'Resetuj', searchedColumn, setSearchedColumn),
        },
        {
            title: "Kategoria",
            dataIndex: "idCategory",
            key: "idCategory",
            width: 160,
            sorter: (a: { idCategory: number; }, b: { idCategory: number; }) => a.idCategory - b.idCategory,
            render: (text: string, record: { type: number; dateAdd: Date; id: number; isActive: number | boolean; taste: number; colour: number; category?: string | undefined; url: string | undefined}) => <TableDateRow record={record} field={TableDataRowTypes.CATEGORY_TAG} />,
        },
        {
            title: "Aktywna",
            dataIndex: "isActive",
            key: "isActive",
            width: '150px',
            render: (text: string, record: { type: number; dateAdd: Date; id: number; isActive: number | boolean; taste: number; colour: number; category?: string | undefined; url: string | undefined}) => (<TableDateRow record={record} field={TableDataRowTypes.IS_ACTIVE} />),
            sorter: (a: { isActive: number; }, b: { isActive: number; }) => a.isActive - b.isActive,
            filters: [
                {
                    text: 'TAK', value: 'isActive',
                },
                {
                    text: "NIE", value: 'isNotActive',
                },
            ],
            onFilter: (value: string, record: { isActive: boolean; }) => {
                if (value === 'isActive') {
                    return record.isActive;
                }
                return !record.isActive;
            },
        },
        {
            title: "Akcje",
            dataIndex: "operation",
            key: "operation",
            width: 100,
            render: (text: string, item: { id: number; }) => {
                return (
                    <Space size="middle">
                        <Tooltip title="Edytuj wpis">
                            <Link to={`/knowledge/${item.id}`}>
                                <Button type="primary" shape="circle" icon={<EditOutlined />} />
                            </Link>
                        </Tooltip>
                        <Tooltip title="Usuń wpis">
                            <Popconfirm
                                title="Czy na pewno chcesz usunąc ten wpis?"
                                placement="left"
                                onConfirm={() => confirmDelete(item.id)}
                                okText="Tak"
                                cancelText="Nie"
                            >
                                <Button type="link">
                                    <DeleteFilled />
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    </Space>
                );
            },
        },
    ];


    return (
        <>
            <Bread>
                <>
                    <Breadcrumb.Item>
                        <HomeOutlined />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Baza wiedzy</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to="/knowledge">Q&A</Link>
                    </Breadcrumb.Item>
                </>
            </Bread>
            <ConfigProvider locale={plPL}>
                <Table
                    // @ts-ignore
                    columns={columns}
                    // @ts-ignore
                    dataSource={tableData}
                    loading={loading}
                    rowKey={record => record.id}
                >
                    <Pagination />
                </Table>
                <BackTop />
            </ConfigProvider>
        </>
    );
};

export default News;
